import ApiClient from './ApiClient';

// get() → { paused, reason, started_at } da pausa aberta do próprio agente.
class MyPauseAPI extends ApiClient {
  constructor() {
    // Resolves to /api/v1/accounts/:account_id/my_pause
    super('my_pause', { accountScoped: true });
  }
}

export default new MyPauseAPI();
